import React from 'react';
import {Link} from 'react-router-dom'

import './style.css'


const CounterSection = (props) => {

    return(
        <div className={`wpo-counter-area ${props.subclass}`}>
            <div className="container">
                <div className="row">
                    <div className="col-lg-7 col-md-6 col-sm-12">
                        <div className="wpo-counter-content">
                            <h2>Driven to Deliver Excellence Every Mile...</h2>
                            <p>At MIDA SPED, we take pride in moving the world forward. With countless packages delivered, a robust fleet of trucks, and a growing base of satisfied customers, we ensure every journey is a step toward reliability, trust, and success. Our commitment to excellence fuels us every mile of the way.</p>

                        </div>
                    </div>
                    <div className="col-lg-5 col-md-6 col-sm-12">
                        <div className="wpo-counter-grids">
                            <div className="grid">
                                <div>
                                    <h2><span>20</span></h2>
                                </div>
                                <p>Trucks</p>
                            </div>
                            <div className="grid">
                                <div>
                                    <h2><span>44</span></h2>
                                </div>
                                <p>Countries Covered</p>
                            </div>
                            <div className="grid">
                                <div>
                                    <h2><span>10000+</span></h2>
                                </div>
                                <p>Delivered Packages</p>
                            </div>
                            <div className="grid">
                                <div>
                                    <h2><span>1000+</span></h2>
                                </div>
                                <p>Satisfied Clients</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
     )
        
}

export default CounterSection;
